
/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, HostListener, ChangeDetectionStrategy, ChangeDetectorRef, Inject, OnDestroy, NgZone } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subject } from "rxjs/internal/Subject";
import { TranslateService } from "@ngx-translate/core";
import { MailOperations } from "../../common/enums/mail-enum";
import { MailBroadcaster } from "../../common/providers/mail-broadcaster.service";
import { BroadcastKeys } from "../../common/enums/broadcast.enum";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "vp-color-control-dialog",
  templateUrl: "./color-control-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ColorControlDialogComponent implements OnDestroy {

  private isAlive$ = new Subject<boolean>();
  mailOperations = MailOperations;
  existingColor: any = "black";

  constructor(
    private dialogRef: MatDialogRef<ColorControlDialogComponent>,
    private changeDetection: ChangeDetectorRef,
    private mailBroadcaster: MailBroadcaster,
    private ngZone: NgZone,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.folderColor) {
      this.existingColor = data.folderColor;
    }
    this.mailBroadcaster.on<any>(BroadcastKeys.HIDE_COLOR_DIALOG).pipe(takeUntil(this.isAlive$)).subscribe(res => {
      this.ngZone.run(() => {
        this.dialogRef.close();
      });
    });
    this.changeDetection.markForCheck();
  }

  handleColorChange(event) {
    this.existingColor = event.color.hex;
  }

  @HostListener("keydown.esc")
  public hideDialog(): void {
    this.dialogRef.close({ selectedColor: null });
  }

  changeColor() {
    this.dialogRef.close({ selectedColor: this.existingColor });
  }

  close(): void {
    this.dialogRef.close({ selectedColor: null });
  }

  ngOnDestroy() {
    this.isAlive$.next(false);
    this.isAlive$.unsubscribe();
  }
}
